module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/12-6d1b1c79a037e76d0c2fa373492a3567.png";